import type * as api from '@gitbook/api-client';
import type { IconName as FAIconName } from '@gitbook/icons';
import { Icon } from '@gitbook/spine-icons';

import { ContentIcon } from '../Icons';

export function SiteSectionGroupIcon(props: {
    siteSectionGroup: api.SiteSectionGroup;
    size?: number;
    className?: string;
}) {
    const { siteSectionGroup, ...iconProps } = props;
    return siteSectionGroup.icon ? (
        <ContentIcon icon={siteSectionGroup.icon as FAIconName} {...iconProps} />
    ) : (
        <Icon.SiteGroup {...iconProps} />
    );
}
